;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.4";import * as Sentry from "@sentry/nextjs";

const SENTRY_ENABLED = document.querySelector<HTMLMetaElement>(
  'meta[name="sentry-enabled"]',
)?.content;
const SENTRY_DSN =
  document
    .querySelector<HTMLMetaElement>('meta[name="sentry-dsn"]')
    ?.getAttribute("content") || undefined;
const ENVIRONMENT = document.querySelector<HTMLMetaElement>(
  'meta[name="sentry-env"]',
)?.content;
const SENTRY_RELEASE_NAME = document.querySelector<HTMLMetaElement>(
  'meta[name="sentry-release-name"]',
)?.content;
const SENTRY_RELEASE_VERSION = document.querySelector<HTMLMetaElement>(
  'meta[name="sentry-release-version"]',
)?.content;
const BUILD_ID = document.querySelector<HTMLMetaElement>(
  'meta[name="build-id"]',
)?.content;

Sentry.init({
  enabled: SENTRY_ENABLED === "true",
  sampleRate: 0.25,
  dsn: SENTRY_DSN,
  environment: ENVIRONMENT,
  release: `${SENTRY_RELEASE_NAME}@${SENTRY_RELEASE_VERSION}`,
  dist: BUILD_ID,
  integrations: [
    Sentry.extraErrorDataIntegration(),
    Sentry.httpClientIntegration(),
  ],
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
